<template>
  <v-icon
    class="info-icon mx-1 mb-1"
    icon="mdi-information"
    size="xs-small"
    @click="() => (state = true)"
  />

  <v-dialog v-model="state">
    <v-container fluid>
      <v-row justify="center">
        <v-col sm="12" md="8" xl="5" xxl="4">
          <v-card class="pa-4 popup-card">
            <v-card-title>
              <div class="d-flex justify-space-between">
                {{ title }}
                <v-icon
                  class="info-icon"
                  icon="mdi-close"
                  @click="() => (state = false)"
                />
              </div>
            </v-card-title>
            <v-card-text v-for="section in formatContent(content)">
              {{ section }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref } from "vue";

withDefaults(
  defineProps<{
    title: string;
    content: string;
  }>(),
  {
    title: "",
    content: "",
  }
);

const state = ref(false);

function formatContent(input: string) {
  return input.split("\n") ?? input;
}
</script>

<style scoped lang="scss">
.info-icon {
  cursor: pointer !important;
}
.popup-card {
  border-radius: 12px;
}
</style>
